import _Object$values from '@babel/runtime-corejs3/core-js-stable/object/values';

var FOOTER_TYPE = {
  MY_ASSET: 'myAsset',
  PAYMENT: 'payment',
  LOAN: 'loan',
  INSURANCE: 'insurance',
  SAVINGS: 'savings',
  CARD: 'card',
  STOCK: 'stock',
  REAL_ESTATE: 'realEstate'
};
var FOOTER_TYPE_VALUES = _Object$values(FOOTER_TYPE);
var FOOTER_QUICK_MENU_TITLE = {
  LOGIN: '로그인',
  LOGOUT: '로그아웃',
  ALL_SERVICE: '전체서비스',
  SHOPPING_PAY_HELP: '쇼핑&페이 고객센터',
  TERMS_POLICY: '약관 및 정책',
  PRIVACY: '개인정보처리방침',
  CREDIT_INFO_USAGE: '신용정보 활용체제',
  NPAY_AD_POINT: '네이버페이 광고&포인트',
  INDEMNIFICATION_PROVISION: '면책조항',
  SAVINGS_INTEREST_RATE_INFO: '예적금 금리정보',
  LOAN_SOLICITATION_TERMS: '대출모집서비스 이용약관',
  STOCK_LOCAL_NEWS_TERMS_POLICY: '이용약관',
  STOCK_LOCAL_NEWS_PRIVACY: '개인정보처리방침',
  STOCK_HELP: '증권 고객센터',
  ARTICLE_ARRANGEMENT_MANAGER: '기사배열 원칙 책임자 : 유봉석',
  JUVENILE_PROTECTION_MANAGER: '청소년 보호 책임자 : 이희만',
  STOCK_NOTICE: '공지사항',
  STOCK_ERROR_REPORT: '오류신고',
  REAL_ESTATE_HELP: '부동산 도움말',
  NAVER_FINANCIAL_TERMS_POLICY: '이용약관',
  REAL_ESTATE_OPEN_SOURCE_LICENSE: '오픈소스 라이선스',
  REAL_ESTATE_INSURANCE_HELP: '반환보증 도움말',
  REAL_ESTATE_COMPLEX_EDIT_SUGGESTION: '단지정보 수정 제안',
  REAL_ESTATE_COMPLEX_NEW_REQUEST: '단지정보 신규 요청'
};

export { FOOTER_QUICK_MENU_TITLE, FOOTER_TYPE, FOOTER_TYPE_VALUES };
